
//
// Rebolt Bundler
//

document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener("model-changed", modelChanged);
    const observer = new MutationObserver(() => {
        if (document.querySelector("select.RB_PC_Selector")) {
            modelChanged();
            observer.disconnect();
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });
})
function modelChanged() {
    let phoneModel = localStorage.getItem("selectedModelOption_phone");
    let airpodModel = localStorage.getItem("selectedModelOption_airpod");
    if (phoneModel || airpodModel) {
        const selects = document.querySelectorAll("select.RB_PC_Selector");
        selects.forEach(s => {
            const matchingOption = Array.from(s.options).find(o => o.innerText == phoneModel || o.innerText == airpodModel);
            if (matchingOption) {
                s.selectedIndex = matchingOption.index;
                // Simulate user interaction
                const event = new Event('change', { bubbles: true });
                s.dispatchEvent(event);
            }
        })
    }
}
//
//Rebolt bundler
//